import { Link } from "react-router-dom";

const ContactsForCall = () => {
  return (
    <div className="w-full flex flex-col md:flex-row md:justify-start">
      <div className="w-full max-w-xs flex flex-col text-[14px]">
        <h6 className="pt-5 font-semibold">Центральний офіс «Сільпо»</h6>
        <div className="max-w-[11.5rem]">
          <span className="font-normal">
            Україна, 02152, м. Київ просп. Павла Тичини, 1-В
          </span>
        </div>
        <Link
          to="https://silpo.ua/contacts"
          target="_blank"
          className="text-[#2458D3]"
        >
          Більше контактів на silpo.ua
        </Link>
      </div>

      <div className="w-full text-[14px]">
        <div className="pt-5 text-[14px]">
          <h6 className="font-semibold">Радіо «Сільпо»</h6>
          <span className="opacity-70">e-mail: </span>
          <a href="mailto:radio-silpo@fozzy.ua" className="text-[#2458D3]">
            radio-silpo@fozzy.ua
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactsForCall;
